<template>
  <div :class="classes">
      <pt-page-title title="优惠劵审核"></pt-page-title>
       <pt-page-menu-filter :tabs="pageTab" v-model="queryParams.auditStatus"></pt-page-menu-filter>
       <pt-coupon-table :queryParams="queryParams" ref="table" :audit-status="queryParams.auditStatus">
           <el-table-column label="操作">
               <template slot-scope="scope">
                   <el-button type="text" @click="couponDetail(scope.row)">详情</el-button>
                <template v-if="HAS_COUPON_REVIEW">
                    <el-button type="text" @click="pass(scope.row)">审核通过</el-button>
                    <el-button type="text" @click="reject(scope.row)">驳回</el-button>
                </template>
                <!-- <template v-else>
                    <el-button type="text" @click="couponDetail(scope.row)">详情</el-button>
                </template> -->
               </template>
           </el-table-column>
       </pt-coupon-table>
       <el-dialog :visible="is_dialog" :title="dialog_title" :class="$style['review-coupon-dialog']" @close="closeDialog">
           <coupon-reject v-if="is_reject" :coupon-detail="coupon_detail" @close="closeDialog"></coupon-reject>
       </el-dialog>
  </div>
</template>

<script>
import { pageTab } from './coupon-review.js'
import ptCouponTable from '../pt-promotion-coupon/pt-coupon-table/withData'
import couponReject from './coupon-reject'
import { hasPermissions } from 'utils/permissions'
const PERM_MALL_PROMOTIONS_APPROVAL = 'PERM_MALL_PROMOTIONS_APPROVAL'// 优惠劵审批架权限
// 组件class前缀
const prefixCls = 'pt-coupon-review'

export default {
  name: 'pt-coupon-review',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_reject
      },
      set: function (val) {
        this.is_reject = val
      }
    },
    // 是否拥有优惠劵上架审核权限
    HAS_COUPON_REVIEW () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALL_PROMOTIONS_APPROVAL) && this.queryParams && this.queryParams.auditStatus === 'UNAUDITED'
    }
  },
  components: {
    ptCouponTable,
    couponReject
  },
  data () {
    return {
      pageTab: pageTab,
      queryParams: {
      },
      dialog_title: '',
      is_reject: false,
      coupon_detail: {}
    }
  },
  methods: {
    closeDialog (val) {
      this.is_dialog = false
      if (val) {
        this.$refs.table.couponList(0)
      }
    },
    coupon_list () {
      let page = this.$refs.table.page
      this.$refs.table.couponList(page)
    },
    reject (val) {
      this.dialog_title = '优惠劵驳回'
      this.is_reject = true
      this.coupon_detail = val
    },
    couponDetail (val) {
      this.$router.push('/coupon-review/coupon-detail/' + val.id)
    },
    pass (val) {
      this.$confirm('您确定审核通过该优惠劵吗', '优惠劵审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
        this.$emit('pass', val)
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.review-coupon-dialog{
     :global
    .el-dialog{
        width: 30%;
        min-width:300PX;
    }
    .el-dialog__body{
        padding: 15px 20px 30px
    }
}
</style>
